(function () {
  const MQ = window.matchMedia('(max-width: 749px)');

  function findHeading(block) {
    return (
      block.querySelector('.footer-block__heading') ||
      block.querySelector('.footer__heading') ||
      block.querySelector('[data-footer-block-title]') ||
      block.querySelector('h2, h3, h4') ||
      block.querySelector('p, span, div')
    );
  }

  function findContent(block) {
    // IMPORTANT: wrapper first so everything hides correctly + stacks under heading
    return (
      block.querySelector('.footer-block__details-content') ||
      block.querySelector('.footer-block__content') ||
      block.querySelector('.footer__content') ||
      block.querySelector('.footer__list') ||
      block.querySelector('nav') ||
      block.querySelector('ul') ||
      block.querySelector('ol')
    );
  }

  function isExcludedBlock(block) {
    return (
      block.matches(
        '.footer-block--newsletter, .footer-block--email, .footer-block--social, .footer-block--payment'
      ) ||
      block.querySelector('form') ||
      block.querySelector('input[type="email"]')
    );
  }

  function makeAccordion(block) {
    if (block.classList.contains('footer-acc')) return;
    if (isExcludedBlock(block)) return;

    const heading = findHeading(block);
    const content = findContent(block);

    if (!heading || !content) return;
    if (content.contains(heading)) return;

    const titleText = (heading.textContent || '').trim();
    if (!titleText) return;

    block.classList.add('footer-acc');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'footer-acc__btn';
    btn.setAttribute('aria-expanded', 'false');

    btn.innerHTML = `
      <span class="footer-acc__title">${titleText}</span>
      <span class="footer-acc__icon" aria-hidden="true"></span>
    `;

    const panel = document.createElement('div');
    panel.className = 'footer-acc__panel';

    // Move the WHOLE wrapper content into the panel
    panel.appendChild(content);

    // Replace heading with button and add panel after it
    heading.replaceWith(btn);
    btn.insertAdjacentElement('afterend', panel);

    // Start closed
    panel.style.maxHeight = '0px';

    btn.addEventListener('click', () => {
      const isOpen = block.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  }

  function initFooterAccordion() {
    if (!MQ.matches) return;

    const footer = document.querySelector('.footer-content');
    if (!footer) return;

    Array.from(footer.children).forEach(makeAccordion);
  }

  function refreshHeights() {
    document
      .querySelectorAll('.footer-acc.is-open .footer-acc__panel')
      .forEach((panel) => {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
  }

  document.addEventListener('DOMContentLoaded', initFooterAccordion);
  document.addEventListener('shopify:section:load', initFooterAccordion);

  window.addEventListener('resize', () => {
    clearTimeout(window.__footerAccT);
    window.__footerAccT = setTimeout(() => {
      initFooterAccordion();
      refreshHeights();
    }, 200);
  });
})();
